import { Maybe } from "../../../types/types"

export const getAllowedTransitions = (currentState: Maybe<string>) => {

    if (!currentState) {
        return []
    }

    const transitionsMap: any = {
        "1": [],
        "2": ["3", "4"],
        "3": [],
        "4": ["2"],
        "5": ["2"]
    }

    return transitionsMap[currentState]
}

